<div class="email-template-content">
    <mat-tab-group>
        <mat-tab label="Email Template" [formGroup]="form">
            <div class="pt-3">
                <div>
                    <mat-form-field style="max-width: 200px">
                        <input aria-label="From Email"
                               formControlName="fromAddress"
                               matInput
                               placeholder="From email" />
                        <mat-error *ngIf="form.controls.fromAddress.invalid">Invalid email address.</mat-error>
                    </mat-form-field>
                    @FBOLinx.com
                </div>

                <div>
                    <mat-form-field>
                        <input aria-label="Reply To"
                               formControlName="replyTo"
                               matInput
                               placeholder="Reply To: The address replies will be sent to" />
                        <mat-error *ngIf="form.controls.replyTo.invalid">Invalid email address.</mat-error>
                    </mat-form-field>
                </div>

                <mat-form-field>
                    <input aria-label="Subject"
                           matInput
                           placeholder="Subject"
                           formControlName="subject" />
                    <mat-error *ngIf="form.controls.subject.invalid">Subject is required.</mat-error>
                </mat-form-field>
                <app-text-editor #typeEmail 
                                formControlName="emailContentHtml"
                                placeholder="Enter email body here..." 
                ></app-text-editor>
            </div>
        </mat-tab>

        <mat-tab label="Logo">
            <div class="pt-3">
                <label>Upload your logo</label><br />
                <input
                    type="file"
                    (change)="onFileChange($event)"
                    accept=".jpg,.jpeg,.png"
                />
                <button
                    *ngIf="!isLogoUploading"
                    (click)="uploadFile()"
                    class="ml-3"
                    color="accent"
                    mat-raised-button
                >
                    Upload File
                </button>
                <div>
                    <button mat-icon-button (click)="alignLogo(AlignmentEnum.LEFT)" matToolTip="Align Left">
                        <mat-icon>format_align_left</mat-icon>
                    </button>
                    <button mat-icon-button (click)="alignLogo(AlignmentEnum.CENTER)" matToolTip="Align Center">
                        <mat-icon>format_align_center</mat-icon>
                    </button>
                    <button mat-icon-button (click)="alignLogo(AlignmentEnum.RIGHT)" matToolTip="Align Right">
                        <mat-icon>format_align_right</mat-icon>
                    </button>
                </div>
                <button
                    *ngIf="logoUrl"
                    (click)="deleteFile()"
                    class="ml-1"
                    color="warn"
                    mat-raised-button
                >
                    Delete
                </button>
                <div *ngIf="isLogoUploading">
                    <mat-spinner></mat-spinner>
                </div>
                <div *ngIf="logoUrl">
                    <img
                        width="300"
                        height="auto"
                        src="{{ 'data:' + logoUrl }}"
                        [style]="logoAlignmentStyle"
                    />
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    <div class="dialog-actions">
        <button
            [disabled]="form.invalid"
            (click)="update()"
            class="mr-1"
            color="accent"
            mat-flat-button
        >
            Update Email Template
        </button>
        <button (click)="cancel()" class="mr-1" mat-stroked-button>
            Cancel
        </button>
    </div>
</div>
